import React from 'react'
import GitHubButton from './GitHubLaunchRepo'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { assets } from '../assets/assets';

const seg1 = `_, mask_otsu = cv2.threshold(gray, 0, 255, cv2.THRESH_BINARY_INV + cv2.THRESH_OTSU) # creats an otsu mask // seperates into two classes foreground and backgroudn
# finds the best global threshold value


adaptive = cv2.adaptiveThreshold( # handles uneven lighting
    gray, 255,
    cv2.ADAPTIVE_THRESH_GAUSSIAN_C,
    cv2.THRESH_BINARY_INV,
    11, 2
)
chosen_mask = mask_clean

kernel = np.ones((3,3), np.uint8)

opening = cv2.morphologyEx(chosen_mask, cv2.MORPH_OPEN, kernel, iterations=2) # removes small noise

dist = cv2.distanceTransform(opening, cv2.DIST_L2, 5)
_, dist_thresh = cv2.threshold(dist, 0.15 * dist.max(), 255, 0)
dist_thresh = np.uint8(dist_thresh)

contours, _ = cv2.findContours(dist_thresh, cv2.RETR_EXTERNAL, cv2.CHAIN_APPROX_SIMPLE)

min_area = 50  # tweak depending on nucleus size
filtered_contours = [cnt for cnt in contours if cv2.contourArea(cnt) > min_area]
print("After filtering:", len(filtered_contours))

img_contours = img.copy()
cv2.drawContours(img_contours, filtered_contours, -1, (255,0,0), 2)

fig, ax = plt.subplots(1, 4, figsize=(16,4))
ax[0].imshow(gray, cmap='gray'); ax[0].set_title('Grayscale')
ax[1].imshow(mask_otsu, cmap='gray'); ax[1].set_title('Otsu Mask')
ax[2].imshow(opening, cmap='gray'); ax[2].set_title('After Morphology')
ax[3].imshow(img_contours); ax[3].set_title('Contours')
for a in ax: a.axis('off')
plt.show()

print("Number of nuclei found:", len(filtered_contours))`

const seg2 = `# not used but allows for different option
chosen_mask = mask_clean 

total_pixels = chosen_mask.shape[0] * chosen_mask.shape[1] # depends on resolution of image
white_pixels = np.sum(chosen_mask == 255)
density_ratio = 1 - (white_pixels / total_pixels)

print(density_ratio)

density_cutoff = .3
cleaning_kernel_size = 3

if density_ratio > density_cutoff:
    # Use high threshold for low-density, clean images (e.g., Image 1)
    chosen_mask = mask_clean 
    marker_threshold = 0.45 # Lower value to get markers in merged areas   
    cleaning_kernel_size = 2 # essential for noise/ artifact removal
    print(f"Low Density Detected ({density_ratio:.2f}). Using THRESHOLD: 0.45")
else:
    chosen_mask = mask_clean 
    marker_threshold = 0.15 # Higher value to keep markers small and clean
    cleaning_kernel_size = 2
    print(f"High Density Detected ({density_ratio:.2f}). Using THRESHOLD: 0.15")
     

kernel = np.ones((cleaning_kernel_size, cleaning_kernel_size), np.uint8)
# Step 1: Morphological cleaning
opening = cv2.morphologyEx(chosen_mask, cv2.MORPH_OPEN, kernel, iterations=1)

# Step 2: Sure background (expanded area)
sure_bg = cv2.dilate(opening, kernel, iterations=2)

# Step 3: Sure foreground (centers of nuclei)
dist_transform = cv2.distanceTransform(opening, cv2.DIST_L2, 5) 
    # this is Distance Transform, calculating the distance between the white and black pixels
_, sure_fg = cv2.threshold(dist_transform, marker_threshold * dist_transform.max(), 255, 0) 
    # it results in an image where the center of each nucleus is represented by a peak of high intensity 
sure_fg = np.uint8(sure_fg)

# Step 4: Unknown region (edges between nuclei)
unknown = cv2.subtract(sure_bg, sure_fg)

# Step 5: Marker labelling for watershed
_, markers = cv2.connectedComponents(sure_fg) 
markers = markers + 1  # make sure background is not 0
markers[unknown == 255] = 0

# Step 6: Apply watershed #
img_ws = img.copy()
markers = cv2.watershed(img_ws, markers)

boundary_mask = (markers == -1).astype(np.uint8) * 255 

kernel = np.ones((2, 2), np.uint8) # A 2x2 or 3x3 kernel works well for slight thickening
dilated_boundaries = cv2.dilate(boundary_mask, kernel, iterations=1)

img_ws[dilated_boundaries == 255] = [255, 0, 0]

# Step 7: Count distinct nuclei
num_nuclei = np.max(markers) - 1  # background is 1
print("Number of nuclei found:", num_nuclei)

# Visualize
fig, ax = plt.subplots(1, 4, figsize=(18,4))
ax[0].imshow(gray, cmap='gray'); ax[0].set_title('Grayscale')
ax[1].imshow(chosen_mask, cmap='gray'); ax[1].set_title('Clean Mask')
ax[2].imshow(opening, cmap='gray'); ax[2].set_title('Morphology Mask')
ax[3].imshow(img_ws); ax[3].set_title('Watershed Result')
for a in ax: a.axis('off')
plt.show()


`

const Datascience = () => {
  return (
    <div className='mx-auto lg:w-1/2 flex flex-col justify-center mt-10 px-10'>
        <div>
        <img className=' mb-5 w-full rounded' src={assets.cellsV1} alt='Data Science Banner'/>
        
        <details className="border-none rounded-lg">
                <summary className="cursor-pointer p-2 font-bold text-lg bg-gray-800 text-white rounded-lg">
                    Original Cleanup
                </summary>
                    <SyntaxHighlighter language="jsx" style={oneDark} showLineNumbers>
                        {seg1}
                    </SyntaxHighlighter>
            </details>
        </div>
        

        <img className='mx-auto my-5 w-full rounded' src={assets.cellsV2} alt='Data Science Banner'/>

        <div>
        <details className="border-none rounded-lg">
                <summary className="cursor-pointer p-2 font-bold text-lg bg-gray-800 text-white rounded-lg">
                    Density Based Cleanup
                </summary>
                    <SyntaxHighlighter language="jsx" style={oneDark} showLineNumbers>
                        {seg2}
                    </SyntaxHighlighter>
            </details>
        </div>
       

        <div className='items-center flex justify-center m-5'>
        <GitHubButton link = "https://github.com/walkmoody/DataScienceBowl/blob/main/train.ipynb"/>
        </div>
    </div>
  )
}

export default Datascience
